import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import AirHandlingUnitDetail from '../../components/ac_central/AirHandlingUnitDetail';
import { defaultRejectHandler, toCoolingCap } from '../../utils/utility';
import { createAirHandlingUnit } from '../../redux/ac_central/air_handling_unit_actions';

class AirHandlingUnitCreateModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    this.ahuDetail = undefined;
  }

  onSaveHandler() {
    const newAHU = this.ahuDetail.getWrappedInstance().getWrappedInstance().getAHUData();
    this.props.createAirHandlingUnit(newAHU);
  }

  render() {
    const { isCreating, errorMessage, ahuDetail, t, getAirHandlingUnit, editAirHandlingUnit, ...newProps } = this.props;
    const { isSubmittable } = this.state;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('create air handling unit')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AirHandlingUnitDetail
            ahu={ahuDetail}
            ref={ref => (this.ahuDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isCreating && !this.props.isCreated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="air-conditioning-air-handling-unit-submit-create"
            disabled={!isSubmittable || isCreating}
            onClick={() => this.onSaveHandler()}
          >
            {isCreating ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, props) => ({
  errorMessage: state.ac.airHandlingUnit.errorMessage,
  isCreating: state.ac.airHandlingUnit.isCreating,
  ahuDetail: props.ahu && state.ac.airHandlingUnit.objects[props.ahu.id],
});

const mapDispatchToProps = dispatch => ({
  createAirHandlingUnit: ahu =>
    defaultRejectHandler(
      dispatch(
        createAirHandlingUnit(
          ahu.name,
          ahu.type,
          toCoolingCap(ahu.cooling_capacity, ahu.unit),
          ahu.unit,
          ahu.power_required,
          ahu.description,
          ahu.image,
        ),
      ),
    ),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AirHandlingUnitCreateModal),
);



// WEBPACK FOOTER //
// ./src/modal/ac_central/AirHandlingUnitCreateModal.js